import { Base, createApp } from '@studiometa/js-toolkit';
import 'liquid-ajax-cart';
import Shop from './components/Shop/index.js';
import Sections from './components/Sections/index.js';
import Toast from './components/Shop/Toast/index.js';
import { mountJudgemeCarouselDots } from './components/Sections/JudgemeCarouselDots.js';

/**
 * App
 */
class App extends Base {
  /**
   * App Configuration
   */
  static config = {
    name: 'App',
    components: {
      Shop,
      Sections,
      Toast,
    },
  };

  /**
   * Toaster
   * @returns {Toast}
   */
  get Toaster() {
    if (this.$children.Toast.length <= 0) {
      throw new Error('No Toast component found');
    }

    return this.$children.Toast[0];
  }
}

mountJudgemeCarouselDots();

export default createApp(App, {
  root: document.documentElement,
  screens: {
    '2xs': '0rem',
    xs: '30rem',
    s: '40rem',
    m: '48rem',
    l: '64rem',
    xl: '80rem',
    '2xl': '96rem',
    '3xl': '120rem',
  },
});
